import { BrowserModule } from '@angular/platform-browser';
import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { CreditCardDirectivesModule } from 'angular-cc-library';
import { CurrencyMaskConfig, CurrencyMaskModule, CURRENCY_MASK_CONFIG } from 'ng2-currency-mask';
import { FlexLayoutModule} from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HttpHandler, HttpInterceptor, HTTP_INTERCEPTORS, HttpRequest } from '@angular/common/http';
import { NgbModule, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { Injectable, NgModule } from '@angular/core';

import { ActionComponent } from './payment-hub/action/action.component';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { AutofocusDirective } from './common/directive/autofocus.directive';
import { ConfirmationDialogComponent } from './common/component/confirmation-dialog/confirmation-dialog.component';
import { CustomerComponent } from './customer/customer.component';
import { DateFormatter } from './common/utility/date.formatter';
import { DateFormatterPipe } from './common/utility/payment-enum';
import { NumberonlyDirective, TwoDigitDecimaNumberDirective } from './common/directive/number.directive';
import { OTPComponent} from './otp/otp.component';
import { PaymentHubComponent } from './payment-hub/payment-hub.component';
import { PaymentComponent } from './payment-hub/payment/payment.component';
import { PhoneMaskDirective } from './common/directive/phone-mask.directive';
import { RecurringComponent } from './payment-hub/recurring/recurring.component';
import { TruncatePipe } from './common/pipes/truncate.pipe';
import { TextMaskModule } from 'angular2-text-mask';
import { WalletComponent } from './payment-hub/wallet/wallet.component';
import { CharCounterDirective} from './common/directive/char-counter.directive';

export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
    align: 'right',
    allowNegative: false,
    decimal: ',',
    precision: 2,
    prefix: '$ ',
    suffix: '',
    thousands: '.'
};

@Injectable()
  export class NoCacheHeadersInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const authReq = req.clone({
      setHeaders: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache'
      }
    });
    return next.handle(authReq);
  }
}

@NgModule({
  declarations: [
    AppComponent,
    ActionComponent,
    AutofocusDirective,
    ConfirmationDialogComponent,
    CustomerComponent,
    CharCounterDirective,
    DateFormatterPipe,
    NumberonlyDirective,
    OTPComponent,
    PaymentHubComponent,
    PaymentComponent,
    PhoneMaskDirective,
    RecurringComponent,
    TruncatePipe,
    TwoDigitDecimaNumberDirective,
    WalletComponent
    ],
  imports: [
    AppRoutingModule, BrowserModule, CommonModule, CreditCardDirectivesModule, CurrencyMaskModule, FlexLayoutModule, FormsModule, HttpClientModule, NgbModule, ReactiveFormsModule, TextMaskModule
    ],
  exports: [
    PhoneMaskDirective
    ],
  providers: [CurrencyPipe, DatePipe,
    { provide: NgbDateParserFormatter,
      useClass: DateFormatter },
    { provide: CURRENCY_MASK_CONFIG,
      useValue: CustomCurrencyMaskConfig },
    { provide: HTTP_INTERCEPTORS,
      useClass: NoCacheHeadersInterceptor,
      multi: true
    }],
  bootstrap: [AppComponent],
  entryComponents: [ConfirmationDialogComponent]
})


export class AppModule { }
